<template>
  <PreloaderComponent v-show="!isLoaded" />
  <div v-show="isLoaded" class="tsl">
    <p class="tsl__header">Заявление об отказе от договора добровольного страхования</p>
    <p class="tsl__contract" v-if="data.agreement_number && data.agreement_date">
      {{ agreementInfoComputed }}
    </p>
    <p class="tsl__text tsl__text_mt">Уважаемый клиент, для расторжения договора, просьба, ознакомьтесь с
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/70d/%D0%9F%D0%BE%D1%80%D1%8F%D0%B4%D0%BE%D0%BA_%D1%80%D0%B0%D1%81%D1%82%D0%BE%D1%80%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F_%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%B0.pdf">памяткой</a>,
      в которой находятся все необходимые рекомендации для расторжения договора.
    </p>
    <br>
    <p class="tsl__text" v-if="contract.PROGRAM_TYPE === 'cred'">Если вы желаете заполнить заявление вручную, можете
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/1db/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BD%D0%B0_%D1%80%D0%B0%D1%81%D1%82%D0%BE%D1%80%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5_%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%B0.pdf">
        скачать бланк</a> заявления.
    </p>
    <p class="tsl__text" v-if="!cooling && contract.PROGRAM_TYPE !== 'cred'">Если вы желаете заполнить заявление
      вручную, можете
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/363/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%D0%97%D0%B0%D0%9F%D0%B5%D1%80%D0%B8%D0%BE%D0%B4%D0%BE%D0%BC%D0%9E%D1%85%D0%BB%D0%B0%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F.pdf">
        скачать бланк</a> заявления.
    </p>
    <p class="tsl__text" v-if="cooling && contract.PROGRAM_TYPE !== 'cred'">Если вы желаете заполнить заявление вручную,
      можете
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/742/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%D0%92%D0%9F%D0%B5%D1%80%D0%B8%D0%BE%D0%B4%D0%9E%D1%85%D0%BB%D0%B0%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F.pdf">
        скачать бланк</a> заявления.
    </p>
    <div class="tsl__statement-div">
      <label>
        <input type="radio" @click="errors = []; files= []" v-model="type_termination" :value="'e_statement'">
        <span>Электронное заявление</span>
      </label>
      <label>
        <input type="radio" @click="errors = []; files= []" v-model="type_termination" :value="'f_statement'">
        <span>Заявление, заполненное вручную</span>
      </label>
    </div>
    <div v-if="contract.PROGRAM_TYPE === 'cred' && !cooling" class="tsl__text-red">
      <p>Если договор страхования заключён при получении потребительского кредита - для возврата не использованной части
        страховой премии, обязательно приложите документы о закрытии кредитных обязательств.
      </p>
    </div>
    <div v-else-if="contract.PROGRAM_TYPE !== 'cred' && !cooling && moreThen5Years && previousYearOrEarlier"
         class="tsl__text-red">
      <p>В отношении договоров страхования со сроком страхования 5 лет и более в соответствии со статьей 213 НК РФ при
        выплате выкупной суммы Страховая компания, являющаяся налоговым агентом, обязана удержать сумму налога, равную
        сумме социального налогового вычета, на который Страхователь имел право в течение действия договора страхования.
        Страховая компания не удерживает сумму налога, в случае если Страхователем была предоставлена справка из
        налогового органа/получена информация* от налогового органа о неполучении социального налогового вычета в
        отношении средств, уплаченных по договору страхования жизни.
      </p>
      <p class="small-text">* информация от налогового органа предоставляется в ООО «МАКС-Жизнь» в течение 30 дней с
        даты получения настоящего запроса
      </p>
    </div>
    <h1 v-if="type_termination === 'e_statement'" class="tsl__subheader">Страхователь</h1>
    <div v-if="type_termination === 'e_statement'" class="tsl__infoWrapper">
      <div class="tsl__infoWrapper-row">
        <div class="tsl__infoWrapper-input">
          <label>ФИО</label>
          <MakcInputComponent
            type="text"
            placeholder="Фамилия"
            :class="v$.data.full_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.full_name.$model"
            :isDisabled="data.full_name.length > 0"
          />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Дата рождения</label>
          <MakcInputComponent
            type="text"
            placeholder="Дата рождения"
            :class="v$.data.birth_date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.birth_date.$model"
            :isDisabled="data.birth_date.length > 0"
          />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Телефон</label>
          <div class="makc-input-wrapper" :class="v$.data.phone.$errors.length > 0 ? 'field-error' : ''">
            <input
              v-model="v$.data.phone.$model"
              type="text"
              placeholder=""
              v-mask="{
                      mask: '+7 (F##) ###-##-##',
                      tokens: {
                        F: {
                          pattern: /(?!8)\d/,
                        },
                        '#': { pattern: /\d/ },
                      },
                    }"
            />
          </div>
          <ValidationErrorComponent :errors="v$.data.phone.$errors" />
        </div>
      </div>
      <span class="xxxx">Документ, удостоверяющий личность</span>
      <div class="tsl__infoWrapper-row tsl__infoWrapper-row_mt">
        <div class="tsl__infoWrapper-input">
          <select v-model="v$.data.doc_type.$model" :disabled="data.doc_type.length > 0">
            <option
              v-for="(type, key) in doc_type_options" :key="key" :value="key"
            >
              {{ type }}
            </option>
          </select>
        </div>
        <div class="tsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Серия"
            :class="v$.data.doc_serial.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_serial.length > 0"
            v-model="v$.data.doc_serial.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_serial.$errors" />
        </div>
        <div class="tsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Номер"
            :class="v$.data.doc_number.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_number.length > 0"
            v-model="v$.data.doc_number.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_number.$errors" />
        </div>
      </div>
      <div class="tsl__infoWrapper-row tsl__infoWrapper-row_mt2">
        <div class="tsl__infoWrapper-input tsl__infoWrapper-input_width">
          <MakcInputComponent
            type="text"
            placeholder="Кем и когда выдан"
            :class="v$.data.doc_info.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="data.doc_info.length > 0"
            v-model="v$.data.doc_info.$model"
          />
          <ValidationErrorComponent :errors="v$.data.doc_info.$errors" />
        </div>
      </div>
    </div>
    <p class="tsl__info" v-if="cooling || contract.PROGRAM_TYPE === 'cred' && type_termination === 'e_statement'">
      Отказываюсь от нижеуказанного договора добровольного страхования граждан, заключенного между мной и ООО
      «МАКС-Жизнь», и прошу произвести мне возврат оплаченной по договору страхования страховой премии:
    </p>
    <p class="tsl__info" v-if="!cooling && contract.PROGRAM_TYPE !== 'cred' && type_termination === 'e_statement'">
      Отказываюсь от нижеуказанного договора страхования, заключенного между мной и ООО «МАКС-Жизнь», и прошу
      произвести мне выплату выкупной суммы в размере и порядке, предусмотренном договором страхования:
    </p>
    <div v-if="type_termination === 'e_statement'" class="tsl__infoWrapper">
      <div class="tsl__infoWrapper-row">
        <div class="tsl__infoWrapper-input">
          <label>Номер договора</label>
          <MakcInputComponent
            type="text"
            placeholder=""
            :isDisabled="data.agreement_number.length > 0"
            :class="v$.data.agreement_number.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.agreement_number.$model"
          />
          <ValidationErrorComponent :errors="v$.data.agreement_number.$errors" />
        </div>
        <div class="tsl__infoWrapper-input">
          <label>Дата договора</label>
          <input
            type="date" :max="dateNow"
            class="tsl__dateInput"
            :disabled="data.agreement_date.length > 0"
            :class="v$.data.agreement_date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.data.agreement_date.$model"
          >
          <ValidationErrorComponent :errors="v$.data.agreement_date.$errors" />
        </div>
      </div>
      <div class="tsl__infoWrapper-row">
        <div v-if="contract.PROGRAM_TYPE !== 'cred'" class="tsl__infoWrapper-input tsl__infoWrapper-input_2">
          <label class="mt">Причина расторжения</label>
          <select
            class="tsl__textarea"
            :class="v$.reason.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.reason.$model"
          >
            <option v-for="(val, index) in reason_options_other" :key=index :value="index">{{ val }}</option>
          </select>
          <ValidationErrorComponent :errors="v$.reason.$errors" />
        </div>
        <div v-if="contract.PROGRAM_TYPE !== 'cred' && !cooling" class="tsl__infoWrapper-input">
          <label class="mt">Дата прекращения договора</label>
          <input
            type="date" :max="dateNow"
            class="tsl__dateInput"
            :class="v$.date_end.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.date_end.$model"
          >
          <ValidationErrorComponent :errors="v$.date_end.$errors" />
        </div>
        <div v-if="contract.PROGRAM_TYPE === 'cred'" class="tsl__infoWrapper-input tsl__infoWrapper-input_2">
          <label class="mt">Причина расторжения</label>
          <select
            class="tsl__textarea"
            :class="v$.reason.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.reason.$model"
          >
            <option v-for="(val, index) in reason_options_cred" :key=index :value="index">{{ val }}</option>
          </select>
          <ValidationErrorComponent :errors="v$.reason.$errors" />
        </div>
      </div>
      <div v-if="reason === 'other'" class="tsl__infoWrapper-row">
        <div class="tsl__infoWrapper-input">
          <textarea
            placeholder="Причина расторжения" class="tsl__textarea" style="margin-top: 10px;"
            :class="v$.reason_text.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.reason_text.$model"
          >
          </textarea>
          <ValidationErrorComponent :errors="v$.reason_text.$errors" />
        </div>
      </div>
    </div>
    <div v-if="type_termination === 'e_statement'" class="tsl__xxxxWrapper">
      <h3>Денежные средства прошу перечислить по следующим реквизитам:</h3>
      <div class="tsl__xxxxWrapper-row mtX">
        <div class="tsl__xxxxWrapper-input">
          <label>БИК</label>
          <MakcInputComponent
            type="text"
            @input="autoComplit"
            :class="v$.bik.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.bik.$model"
          />
          <ValidationErrorComponent :errors="v$.bik.$errors" />
          <div v-if="autoComplitData.length > 0" class="bik-autocomplete">
            <p v-for="(item, i) of autoComplitData" :key="i" @click="atoInHtml(item)">
              {{ item.label }}
            </p>
          </div>
        </div>
        <div class="tsl__xxxxWrapper-input">
          <label>Корреспондентский счет банка</label>
          <MakcInputComponent
            :fieldType="'number'"
            :class="v$.cor_account.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.cor_account.$model"
          />
          <ValidationErrorComponent :errors="v$.cor_account.$errors" />
        </div>
      </div>
      <div class="tsl__xxxxWrapper-row mtY">
        <div class="tsl__xxxxWrapper-input">
          <label>Наименование банка</label>
          <MakcInputComponent
            type="text"
            :class="v$.bank_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.bank_name.$model"
          />
          <ValidationErrorComponent :errors="v$.bank_name.$errors" />
        </div>
        <div class="tsl__xxxxWrapper-input">
          <label>Расчетный счет</label>
          <MakcInputComponent
            type="text"
            :fieldType="'number'"
            :class="v$.bank_account.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.bank_account.$model"
          />
          <ValidationErrorComponent :errors="v$.bank_account.$errors" />
        </div>
      </div>
    </div>
    <div :class="type_termination === 'e_statement' ? 'mtN' : 'mtN mtN_f'">
      <div v-show="fileInputShow">
        <MakcFilesComponent
          :text="type_termination === 'e_statement' ? '' : 'Отправка дополнительных документов'"
          @load="loadFiles($event)"
          ref="tslFile"
        />
      </div>
      <div v-show="isLoaded" class="">
        <div v-if="errors.length > 0" class="errors">
          <div v-for="(error, key) in errors" :key="key" class="error">
            {{ error }}
          </div>
        </div>
      </div>
      <div class="mtK">
        <label v-if="type_termination === 'f_statement'" class="tsl-file" for="tsl-file">Дослать документы</label>
        <input v-if="type_termination === 'f_statement'" id="tsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle" style="display: none;">
        <MakcButtonComponent
          :disabled="(!agree && !cooling && contract.PROGRAM_TYPE !== 'cred' && moreThen5Years && previousYearOrEarlier) || sending"
          @click="sendData"
          class="primary">
          Отправить заявление
        </MakcButtonComponent>
        <label v-if="type_termination === 'e_statement'" class="tsl-file" for="tsl-file">Вложить дополнительный
          документ</label>
        <input v-if="type_termination === 'e_statement'" id="tsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle" style="display: none;">
        <MakcButtonComponent :disabled="sending" @click="cancel_modal = true">
          Отменить
        </MakcButtonComponent>
      </div>
    </div>
    <div class="mtP" v-if="!cooling && contract.PROGRAM_TYPE !== 'cred' && check_ra">
      <input type="checkbox" disabled name="check_ra" v-model="check_ra">
      <p>С таблицей выкупных сумм ознакомлен(а)</p>
    </div>
    <div class="mtP mtP2"
         v-if="!cooling && contract.PROGRAM_TYPE !== 'cred' && moreThen5Years && previousYearOrEarlier">
      <input type="checkbox" name="agree" v-model="agree">
      <p>
        Я ознакомлен(-а) с <span class="tooltip_span"
                                 data-tooltip="В отношении договоров страхования со сроком страхования 5 лет и более в соответствии со статьей 213 НК РФ при выплате выкупной суммы Страховая компания, являющаяся налоговым агентом, обязана удержать сумму налога, равную сумме социального налогового вычета, на который Страхователь имел право в течение действия договора страхования. Страховая компания не удерживает сумму налога, в случае если Страхователем была предоставлена справка из налогового органа о неполучении социального налогового вычета в отношении средств, уплаченных по договору страхования жизни">
        информацией об удержании налога на доходы физических лиц</span>в случае:
        <br>1) непредоставления оригинала справки, выданной налоговым органом, подтверждающей неполучение
        налогоплательщиком
        социального налогового вычета / получения ООО «МАКС-Жизнь» информации от налогового органа о получении мною,
        налогоплательщиком, социального налогового вычета в соответствии с Налоговым кодексом РФ (в отношении договора
        страхования со сроком страхования 5 лет или более; информация от налогового органа предоставляется в ООО
        «МАКС-Жизнь» в течение 30 дней с даты получения настоящего запроса налоговым органом от страховой организации);
        <br>2) предоставления оригинала справки, выданной налоговым органом, подтверждающей получение мной,
        налогоплательщиком, социального налогового вычета в соответствии с Налоговым кодексом РФ (в отношении договора
        страхования со сроком страхования 5 лет или более).
        <br>В случае отсутствия информации, подтверждающей неполучение налогоплательщиком социального налогового вычета
        на
        дату осуществления выплаты, выплата будет произведена с удержанием налога на доходы физических лиц. При
        предоставлении впоследствии необходимой информации возможен возврат удержанного налога на доходы физических
        лиц.).
      </p>
    </div>
  </div>
  <MakcDialogComponent2
    :title="'Пожалуйста, ознакомьтесь с таблицей выкупных сумм'"
    :text="'При подаче заявления о расторжении после периода охлаждения выплата производится согласно таблице выкупных сумм. Пожалуйста, ознакомьтесь с суммой, подлежащей возврату при расторжении.'"
    :buttons="[{text: 'Назад', action: 'hideDialog'}, {text: 'Далее', action: 'terminate'}]"
    :icon="'warning'"
    :width="'815px'"
    v-model:show="ra_show"
    @cancel="cancel"
    @terminate="terminate"
  />
  <MakcDialogComponent
    :title="'Мы рады продолжить сотрудничество!'"
    :text="formattedText"
    :icon="'success'"
    :width="'815px'"
    btn_text="OK"
    v-model:show="cancel_modal"
    @close_modal="cancel"
  />
  <MakcDialogComponent
    :title="'Заявление успешно подано!'"
    :text="'Отслеживать статус заявления можно в разделе “Поданные заявления”'"
    :icon="'success'"
    :width="'607px'"
    btn_text="OK"
    @close_modal="success_modal"
    v-model:show="success"
  />
</template>

<script>
import { ru } from "date-fns/locale";
import { mask } from "vue-the-mask";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, minLength, integer } from "@vuelidate/validators";
import { url } from "@/profile/composables/url";
import { formatDate, reverseFormatDate } from "@/profile/composables/utils";
import axios from "axios";
import ValidationErrorComponent from "@/profile/components/ValidationErrorComponent.vue";
import MakcInputComponent from "@/profile/components/UI/MakcInputComponent";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent";
import MakcFilesComponent from "@/profile/components/UI/MakcFilesComponent";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";
import MakcDialogComponent2 from "@/profile/components/UI/MakcDialogComponent2";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";

export default {
  components: {
    ValidationErrorComponent,
    MakcInputComponent,
    MakcButtonComponent,
    MakcFilesComponent,
    MakcDialogComponent,
    MakcDialogComponent2,
    PreloaderComponent
  },
  props: {
    id: {
      type: String
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: () => {
    return {
      data: {
        first_name: " ",
        last_name: " ",
        middle_name: " ",
        full_name: "",
        birth_date: "",
        phone: "",
        doc_type: "1",
        doc_number: "",
        doc_serial: "",
        doc_info: "",
        agreement_date: "",
        agreement_number: ""
      },
      isLoaded: false,
      fileInputShow: false,
      check_ra: false,
      ra_show: false,
      cancel_modal: false,
      success: false,
      phoneError: false,
      reason: "",
      reason_text: "",
      // date_end: new Date(),
      date_end: "",
      agree: false,
      cooling: true,
      moreThen5Years: false,
      errors: [],
      contract: {},
      invoice: "", // TODO так и должно быть ?
      bik: "",
      inn: "7702070139", // TODO так и должно быть ?
      bank_name: "",
      bank_account: "",
      cor_account: "",
      files: [],
      type_termination: "e_statement",
      locales: ru,
      doc_type_options: {
        "1": "паспорт гражданина РФ",
        "other": "паспорт иностранного гражданина"
      },
      autoComplitData: [],
      file_valid_types: [
        "doc",
        "docx",
        "rtf",
        "txt",
        "bmp",
        "jpg",
        "jpeg",
        "gif",
        "png",
        "zip",
        "rar",
        "xls",
        "xlsx",
        "pdf"
      ],
      fileErrors: [],
      sending: false,
      reason_options_cred: {
        dosr: "Досрочное погашение кредита",
        dont_know: "Не знал, что оформили страховку при заключении кредитного договора",
        not_need: "Необходимость в страховании отпала",
        imposed: "Договор навязан",
        other: "Иная причина"
      },
      reason_options_other: {
        not_be_able: "Не смогу пополнять договор",
        need_money: "Понадобились деньги",
        small_income: "Маленький доход",
        income_not_guaranteed: "Доход не гарантирован",
        not_informed: "Не проинформировали об очередных взносах",
        long_term: "Длительный срок договора",
        misled: "Ввели в заблуждение - думал, что открыл вклад",
        imposed: "Договор навязан",
        found_better: "Нашел условия лучше",
        agreed_with_the_objections: "Согласился с возражениями родных/близких/друзей",
        does_not_comply: "Не соответствую  декларации Застрахованного",
        negative_experience: "Негативный опыт",
        bad_reviews: "Плохие отзывы о программе/Компании",
        other: "Иная причина"
      }
    };
  },
  validations() {
    return {
      data: {
        full_name: { required },
        birth_date: { required },
        doc_type: { required },
        doc_serial: { required },
        doc_number: { required },
        doc_info: { required, maxLength: maxLength(200) },
        agreement_number: { required },
        agreement_date: { required },
        // формат "+7 (900) 000-00-00" = 18
        phone: { required, minLength: minLength(18) }
      },
      // invoice: { required },
      reason: { required },
      reason_text: this.reason === "other" ? { required } : {},
      date_end: this.contract.PROGRAM_TYPE !== "cred" && !this.cooling ? { required } : {},
      bik: { required, minLength: minLength(9), maxLength: maxLength(9), integer },
      bank_name: { required, maxLength: maxLength(200) },
      bank_account: { required, minLength: minLength(20), maxLength: maxLength(20), integer },
      cor_account: { required, minLength: minLength(20), maxLength: maxLength(20), integer }
    };
  },
  directives: { mask },
  created() {
    // загружаем данные, когда представление создано, данные реактивно отслеживаются
    this.fetchData();
  },
  computed: {
    dateNow() {
      return new Date().toISOString().slice(0, 10);
    },
    formattedText() {
      return `Договор страхования обеспечит вам уверенность и поддержку
в непредвиденной жизненной ситуации.

Благодарим за выбор страховой компании ООО «МАКС-Жизнь».`.replace(/\n/g, "<br>");
    },
    agreementInfoComputed() {
      return `Договор ${this.data.agreement_number} от ${formatDate(this.data.agreement_date)}`;
    },
    previousYearOrEarlier() {
      // Получаем текущую дату и преобразуем её в строку формата YYYY-MM-DD
      const referenceDate = new Date().toISOString().split("T")[0]; // Форматируем в YYYY-MM-DD
      const referenceYear = new Date(referenceDate).getFullYear();
      const checkYear = new Date(this.data.agreement_date).getFullYear(); // Получаем год из текущей даты и даты проверки

      return checkYear <= referenceYear - 1;
    }
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  methods: {
    cancel() {
      this.$router.push({ name: "services" });
    },
    terminate() {
      this.$router.push({ name: "ra", params: { id: this.id } });
    },
    success_modal() {
      this.$router.push({ name: "contract", params: { id: this.id } });
    },
    autoComplit() {
      let params = {
        command: "autocomplit",
        action: "bic",
        term: this.bik,
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios.post(url, { params: params })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            // $this.errors = [];
            // $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            $this.autoComplitData = data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    atoInHtml(item) {
      this.bank_name = item.id;
      this.cor_account = item.cor_acc;
      this.bik = item.bic;
      this.autoComplitData = [];
    },
    loadFiles(item) {
      this.files = item;
    },
    sendData() {
      this.errors = [];
      let d = new Date();
      let size = 0;
      for (let i = 0; i < this.files.length; i++) {
        size += this.files[i].file_size / 1048576;
      }

      if (size > 30) {
        this.errors.push("общий размер добавляемых файлов не может быть более 30МБ");
        return;
      }

      // if (this.reason === "") {
      //   this.errors.push("Укажите причину расторжения");
      //   return;
      // }
      //
      // if (this.reason === "other" && this.reason_text === "") {
      //   this.errors.push("Опишите причину расторжения");
      //   return;
      // }
      let unique_code = String(this.id) + String(d.getTime());
      if (this.v$.$invalid) {
        this.v$.$touch();
        if (this.type_termination === "f_statement") {
          if (this.files.length < 1) {
            this.errors.push("Добавьте файлы");
            return;
          }
          this.sending = true;
          let params = {
            command: "send_termination",
            contract_id: this.id,
            files: this.files,
            type_termination: this.type_termination,
            ins_date: d.toLocaleDateString("ru-RU"),
            token: this.$myApp.token.get(),
            unique_code: unique_code
          };
          let $this = this;
          axios.post(url, { params: params })
            .then(function(response) {
              let data = response.data;
              if (data.state === "ERR") {
                $this.errors = [];
                $this.errors.push(data.msg_text);
              }
              if (data.state === "OK") {
                $this.sending = false;
                $this.success = true;
                // alert('Заявление отправлено');
                // $this.$router.push({ name: 'contract', params: { id: $this.id }});
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          this.errors.push("Для отправки заявления, пожалуйста, заполните все обязательные поля");
        }
        return;
      } else {
        let params;
        if (this.type_termination === "e_statement") {
          let tmp_phone = this.data.phone.replace("(", "");
          tmp_phone = tmp_phone.replace(")", "");
          tmp_phone = tmp_phone.replace("-", "");
          tmp_phone = tmp_phone.replace("-", "");
          tmp_phone = tmp_phone.replace("+", "");
          tmp_phone = tmp_phone.replace(" ", "");
          tmp_phone = tmp_phone.replace(" ", "");
          tmp_phone = tmp_phone.substring(1);

          if (tmp_phone === "0000000000") {
            alert("Введите корректный номер телефона");
            return;
          }

          if (this.contract.PROGRAM_TYPE !== "cred") {
            if (!this.cooling && this.moreThen5Years && !this.agree) {
              this.errors.push("Заявление не отправлено. Пожалуйста, подтвердите ознакомление с информацией об удержании налога");
              return;
            }
            this.sending = true;
            params = {
              command: "send_termination",
              contract_id: this.id,
              files: this.files,
              type_termination: this.type_termination,
              invoice: this.invoice,
              bik: this.bik,
              bank_name: this.bank_name,
              bank_account: this.bank_account,
              cor_account: this.cor_account,
              phone: this.data.phone,
              inn: this.inn,
              ins_date: d.toLocaleDateString("ru-RU"),
              reason: this.reason !== "other" ? this.reason_options_other[this.reason] : this.reason_options_other[this.reason] + ": " + this.reason_text,
              date_end: this.date_end,
              token: this.$myApp.token.get(),
              unique_code: unique_code,
            };
          } else {
            if (!this.cooling && this.reason === "dosr" && this.files.length == 0) {
              this.errors.push("Для отправки заявления, пожалуйста, приложите документы, подтверждающие закрытие потребительского кредита");
              return;
            }
            this.sending = true;
            params = {
              command: "send_termination",
              contract_id: this.id,
              files: this.files,
              type_termination: this.type_termination,
              invoice: this.invoice,
              bik: this.bik,
              bank_name: this.bank_name,
              bank_account: this.bank_account,
              cor_account: this.cor_account,
              phone: this.data.phone,
              inn: this.inn,
              ins_date: d.toLocaleDateString("ru-RU"),
              reason: this.reason !== "other" ? this.reason_options_cred[this.reason] : this.reason_options_cred[this.reason] + ": " + this.reason_text,
              token: this.$myApp.token.get(),
              unique_code: unique_code,
            };
          }
        } else {
          if (this.files.length < 1) {
            this.errors.push("Добавьте файлы");
            return;
          }
          this.sending = true;
          params = {
            command: "send_termination",
            contract_id: this.id,
            files: this.files,
            type_termination: this.type_termination,
            ins_date: d.toLocaleDateString("ru-RU"),
            token: this.$myApp.token.get(),
            unique_code: unique_code,
          };
        }
        let $this = this;
        axios.post(url, { params: params })
          .then(function(response) {
            let data = response.data;
            if (data.state === "ERR") {
              if (data.msg_text === "Токен не указан") {
                location.reload();
              }
              $this.errors = [];
              $this.errors.push(data.msg_text);
            }
            if (data.state === "OK") {
              $this.sending = false;
              $this.success = true;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    fetchData() {
      let params = {
        command: "termination_contract",
        contract_id: this.id,
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios.post(url, { params: params })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            $this.data.first_name = data.contracts.FIRST_NAME;
            $this.data.last_name = data.contracts.LAST_NAME;
            $this.data.middle_name = data.contracts.MIDDLE_NAME;
            $this.data.full_name = `${data.contracts.LAST_NAME} ${data.contracts.FIRST_NAME} ${data.contracts.MIDDLE_NAME}`;
            $this.data.birth_date = formatDate(data.contracts.BIRTH_DATE);
            if (data.contracts.PHONE !== "0000000000" && data.contracts.PHONE !== "73000000000") {
              $this.data.phone = data.contracts.PHONE;
            }
            $this.data.doc_type = data.contracts.DOC_TYPE;
            $this.data.doc_serial = data.contracts.DOC_SERIAL;
            $this.data.doc_number = data.contracts.DOC_NUMBER;
            $this.data.doc_info = `${data.contracts.DOC_AUTH} ${formatDate(data.contracts.DOC_DATE)} `;
            $this.data.agreement_date = reverseFormatDate(data.contracts.POLICY_DATE);
            $this.data.agreement_number = data.contracts.POLICY_SER + " " + data.contracts.POLICY_NUMBER;
            $this.contract = data.contracts;
            $this.check_ra = $this.$myApp.ra.get();
            $this.isLoaded = true;
            $this.isCooling(data);
            $this.isMore5Years(data.contracts);
          }
        })
        .catch(function(error) {
          $this.isLoaded = true;
          console.log(error);
        });
    },
    isCooling(data) {
      if (data.contracts.PROGRAM_TYPE === "isz") {
        if (Number(data.contracts.AMOUNT_CUR) < 1500000) {
          if (data.contracts.STATUS == 7) {
            let period = new Date(),
              date_arr = data.contracts.STATUS_DATE.split("."),
              date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]);
            date_bgn.setDate(date_bgn.getDate() + 30);
            if (date_bgn < period) {
              this.cooling = false;
              if (!this.check_ra) {
                this.ra_show = true;
              }
            }
          } else {
            let period = new Date(),
              date_arr = data.contracts.POLICY_DATE.split("."),
              date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]);
            date_bgn.setDate(date_bgn.getDate() + 14);
            if (date_bgn < period) {
              this.cooling = false;
              if (!this.check_ra) {
                this.ra_show = true;
              }
            }
          }
        } else {
          let period = new Date(),
            date_arr = data.contracts.POLICY_DATE.split("."),
            date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]);
          date_bgn.setDate(date_bgn.getDate() + 14);
          if (date_bgn < period) {
            this.cooling = false;
            if (!this.check_ra) {
              this.ra_show = true;
            }
          }
        }
      } else if (data.contracts.PROGRAM_TYPE === "cred") {
        let period = new Date(),
          date_arr = data.contracts.POLICY_DATE.split("."),
          date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]),
          date_border = new Date(2024, 0, 21),
          programs = ["cred_kz", "pr_sport", "pr_sport_pro", "sport"];
        // period.setDate(period.getDate() + 6);
        if (date_bgn >= date_border) {
          if (data.contracts.PERIOD_COOLING) {
            date_bgn.setDate(date_bgn.getDate() + Number(data.contracts.PERIOD_COOLING));
          } else {
            if (programs.includes(data.contracts.PROGRAM_RULE)) {
              date_bgn.setDate(date_bgn.getDate() + 14);
            } else {
              date_bgn.setDate(date_bgn.getDate() + 30);
            }
          }
        } else {
          date_bgn.setDate(date_bgn.getDate() + 14);
        }
        if (date_bgn < period) {
          this.cooling = false;
        }
      } else {
        let period = new Date(),
          date_arr = data.contracts.POLICY_DATE.split("."),
          date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]);
        date_bgn.setDate(date_bgn.getDate() + 14);
        if (date_bgn < period) {
          this.cooling = false;
          if (!this.check_ra) {
            this.ra_show = true;
          }
        }
      }
    },
    isMore5Years(data) {
      if (data.INS_PERIOD >= 5) {
        let date_arr = data.POLICY_DATE.split("."),
          date_bgn = new Date(date_arr[2], Number(date_arr[1]) - 1, date_arr[0]).getFullYear(),
          now = new Date().getFullYear();
        if (now > date_bgn) {
          this.moreThen5Years = true;
        }
      }
    },
    fileInputHandle(e) {
      this.fileInputShow = true;
      this.$refs.tslFile.loadFiles(e);
    }
  }
};
</script>

<style lang="scss" scoped>
.field-error {
  border: 2px solid red !important;
  outline: 2px solid red !important;
}

.makc-input-wrapper {
  position: relative;

  input {
    width: 100%;
    padding: 7px 10px;
    outline: none;
    border: 1px solid #b8b8b8;
  }

  input:disabled {
    background-color: #ecebeb;
  }
}
</style>